import { ReactNode } from 'react';

import { AccessLevel } from '../../../../types/AccessLevel';
import { CompanyAccessMessage } from '../../../../types/CompanyAccessMessage';
import { CompanyMessage } from '../../../../types/CompanyMessage';
import { GroupMessage } from '../../../../types/GroupMessage';
import { TableBuilder } from '../../../cdl/TableBuilder/TableBuilder';
import { TableBuilderColumn } from '../../../cdl/TableBuilder/TableBuilderColumn';
import { Text } from '../../../cdl/Text/Text';
import { translate } from '../../../common/helpers/translate.helper';
import { Box } from '../../../common/ui/Box';

import { PersonalRole } from './PersonalRole';
import { RoleDiagram } from './RoleDiagram';

interface Data {
    role: ReactNode;
    diagram: ReactNode;
}

interface PersonalRoleSectionProps {
    accessLevel: AccessLevel;
    companyAccesses: CompanyAccessMessage[];
    companies: CompanyMessage[];
    group: GroupMessage;
}

export const PersonalRoleSection = (props: PersonalRoleSectionProps) => {
    const data: Data[] = [
        {
            role: (
                <Text weight="semi">
                    <PersonalRole accessLevel={props.accessLevel} companyAccesses={props.companyAccesses} />
                </Text>
            ),
            diagram: <RoleDiagram companies={props.companies} group={props.group} />,
        },
    ];

    return (
        <Box display="flex" flexDirection="column" gap={16}>
            <Text variant="title" as="h2">
                {translate('personalDetails.role.title')}
            </Text>

            <TableBuilder<Data> data={data} alternateRowColors={false}>
                <TableBuilderColumn<Data> header={translate('user.role')} width="220px">
                    {(row) => row.role}
                </TableBuilderColumn>

                <TableBuilderColumn<Data> header={translate('user.company')}>{(row) => row.diagram}</TableBuilderColumn>
            </TableBuilder>
        </Box>
    );
};
